import { actionTypes, errorTypes } from '@/types';
import logger from '@/tools/logger';

export default function setExhibition(
	{ getters, dispatch },
	{ exhibitionID, articleID, code, retainModal, endTour }
) {
	// TODO: reimplement retainModal
	let article;
	const exhibition = getters.getExhibition(exhibitionID);
	if (!exhibition) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownExhibition) });
		return;
	}

	if (code) {
		if (code !== 'same') {
			article = exhibition.articleMap[exhibition.codeMap[code].articleID];
		} else if (getters.currentExhibition.codeMap && exhibition.codeMap) {
			const codes = Object.keys(getters.currentExhibition.codeMap).filter(
				(key) =>
					getters.currentExhibition.codeMap[key] &&
					getters.currentExhibition.codeMap[key].articleID === getters.currentArticleID
			);
			if (codes[0]) article = exhibition.articleMap[exhibition.codeMap[codes[0]].articleID];
		}
	}
	if (articleID) {
		article = exhibition.articleMap[articleID];
	}
	if (!article) {
		logger.warn('article not found, falling back to landingArticleID');
		article = exhibition.articleMap[exhibition.landingArticleID];
		if (!article) {
			dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownArticle) });
			return;
		}
	}
	const queryParams = Object.entries({ retainModal, endTour }).reduce((acc, [paramKey, paramValue]) => {
		if (paramValue) acc.push(`${paramKey}=true`);
		return acc;
	}, []);
	// prettier-ignore
	const url = `/${exhibition.exhibitionID}/${article.id}${queryParams.length ? `?${queryParams.join('&')}` : ''}`;
	dispatch(actionTypes.pushUrl, { url, replace: false });
}
